// ExamStateAgentPage.tsx

import { useTranslation } from "react-i18next";
import { RealEstateAgent, HomeWork, Domain } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getStateAgentBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("eaqe")) {
      const accent = isDark ? "#fb923c" : "#c2410c";
      return {
        icon: RealEstateAgent,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("sqe")) {
      const accent = isDark ? "#fdba74" : "#ea580c";
      return {
        icon: HomeWork,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#fcd34d" : "#d97706";
    return {
      icon: Domain,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamStateAgentPage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examStateAgent.title")}
      subtitle={t("pages.examStateAgent.subtitle")}
      actionText={t("pages.examStateAgent.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "stateagent", limit: 99 });
        return res.data;
      }}
      brandResolver={getStateAgentBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
